export default __webpack_public_path__ + "static/media/varlyq_interview_question-1_project-12.87a16465.png";